module.exports = __webpack_public_path__ + "static/media/YF80_2.6bba902a.jpg";